import * as React from 'react';

import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import { IoClose } from "react-icons/io5";
import { useEffect } from 'react';
import {
  GetFieldData,
  GetFieldDataWithLoader,
  //  getImagesCSPkyc, 
  SendReuploadFileCspList
} from 'API/Approval/api';
import { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// import ImageModal from 'views/utilities/Components/Approval/Components/ImageModal';
import SnackBar from 'views/utilities/Components/General/SnackBar';
import BackdropLoader from 'views/utilities/Components/General/Loader';
import { CheckActiveApi, DynamicBankAccNumberVerify, DynamicBankVerifyBharat, DynamicGet, getDynamicDataWithParams, UpdateData } from 'API/UserList/CspList';
import { styled } from '@mui/material/styles';
import ViewAllFiles from 'views/utilities/Components/KYC Upload/ViewAllFiles';
import { normalizeDate } from 'utils/DateFormater';


export default function FieldsDialog(props) {

  const [UserData, setUserData] = useState(null)
  const [ModifiedUserData, setModifiedUserData] = useState({})
  // const [Error,setError]=useState(false)
  const [ErrorMessage, setErrorMessage] = useState({})

  // const [OpenImageModel, setOpenImageModel] = useState(false)
  // const [ImageUrl, setImageUrl] = useState(null)
  // const [FileType, setFileType] = useState(null)
  const [ImageAlertOpen, setImageAlertOpen] = useState(false)
  const [IsLoading, setIsLoading] = useState(false)

  const [AlertOpen, setAlertOpen] = useState(false)
  const [AlertMessage, setAlertMessage] = useState("")
  const [AlertSeverity, setAlertSeverity] = useState("")

  const [DynamicData, setDynamicData] = useState(null);
  const [Lastcall, setLastCall] = useState(null);

  const [VerificationStatus, setVerificationStatus] = useState({
    isVerificationAvailable: false,
    isChanged: false,
    isVerified: false,
  });

  const [OpenViewAllDocs, setOpenViewAllDocs] = useState(false)
  const [OpenViewAllDocsData, setOpenViewAllDocsData] = useState(null)



  const handleViewAllDocs = (item, field) => {
    setOpenViewAllDocs(true)
    setOpenViewAllDocsData({ item, field })
    props.SetVisibleClose(false)
  }



  const getVerificationStatus = () => {
    return (
      props?.category?.fields?.some(
        (field) => field.field_type === "Plugin" && field.field_details?.verify === "true"
      ) || false
    );
  };

  useEffect(() => {
    const status = getVerificationStatus();
    console.log("status", status);

    setVerificationStatus((prevState) => ({
      ...prevState,
      isVerificationAvailable: status,
    }));
  }, [props]);


  const handleAlertOpen = (message, type) => {
    setAlertOpen(true)
    setAlertMessage(message)
    setAlertSeverity(type)
  }

  const handleAlertClose = () => {
    setAlertOpen(false)
  }

  const handleCloseViewAllDocs = () => {
    setOpenViewAllDocs(false)
    setOpenViewAllDocsData(null)
    props.SetVisibleClose(true)
    handleAlertClose()
  }
  // const handleImageAlertOpen = () => {
  //     setImageAlertOpen(true)
  // }

  const handleImageAlertClose = () => {
    setImageAlertOpen(false)
  }

  // const handleImgeModelOpen = () => {
  //     setOpenImageModel(true)
  // }

  // const handleImageModelClose = () => {
  //     setOpenImageModel(false)
  // }

  function checkValues() {
    for (let key in ErrorMessage) {
      if (ErrorMessage[key] !== "") {
        return true;
      }
    }
    return false;
  }

  console.log("props: " + props);

  function checkAllValues() {

    for (let key in ModifiedUserData) {
      if ((ModifiedUserData[key] === "" || !ModifiedUserData[key])) {
        let field = props.category.fields.find(item => item.field_name === key)
        if (field && field.required) {
          console.log("key", key);

          return true;
        }
      }
    }
    return false;
  }

  function checkMandatory() {
    const missingFields = props.category.fields.filter(item =>
      item.required === true &&
      !ModifiedUserData[item.field_name] &&
      !UserData[0][item.field_name] &&
      item.field_name !== 'csp_code'
    );

    if (missingFields.length > 0) {
      console.log("Missing mandatory fields:", missingFields.map(f => f.field_name));
      return false;
    }

    return true;
  }



  const GetData = () => {
    let data = props.category.fields.map(field => field.field_name)
    GetFieldData(setUserData, data, props.userId);

  }

  const handleSubmit = () => {
    let errorStatus = checkValues()
    let modifiedData = checkAllValues()
    let mandatory = checkMandatory()
    if (errorStatus) {
      handleAlertOpen("Unable to submit as there are some errors in the form", "error")
      return
    }
    else if (Object.getOwnPropertyNames(ModifiedUserData).length === 0) {
      props.handleClose()
    }
    else if (!mandatory) {
      handleAlertOpen("Please fill all the required fields", "error")
      return
    }
    else if (modifiedData) {
      handleAlertOpen("Please fill all the required fields", "error")
      return
    }
    else if (VerificationStatus.isVerificationAvailable === true && VerificationStatus.isChanged === true && VerificationStatus.isVerified === false) {
      handleAlertOpen("Please fill all the required fields and complete data verification if required", "error")
      return
    }
    else {
      UpdateData(ModifiedUserData, setIsLoading, handleAlertOpen, props.userId, GetData, props.handleClose)
    }
  }


  const handleChange = (field, value) => {
    console.log("change", field);

    if ((!field?.field_details || Object.keys(field?.field_details).length < 1) && field.field_type !== 'bankname' && field.field_type !== 'bankifsc') {
      setErrorMessage(prev => ({ ...prev, [field.field_name]: "" }));
      setModifiedUserData(prev => ({ ...prev, [field.field_name]: updatedValue }));

    }
    let updatedValue = value;
    const { Regex, maxLength, minLength } = field.field_details;

    // Allow empty input
    if (updatedValue === "") {
      setModifiedUserData(prev => ({ ...prev, [field.field_name]: "" }));
      // setError(false);
      setErrorMessage(prev => ({ ...prev, [field.field_name]: "" }));
      return;
    }

    // Apply maxLength constraint
    if (maxLength && updatedValue.length > maxLength) {
      updatedValue = updatedValue.slice(0, maxLength);
    }

    if (Regex) {
      const regex = new RegExp(Regex);
      if (!regex.test(updatedValue)) {
        if (field.field_name.includes("email")) {
          // setError(true);
          setErrorMessage(prev => ({ ...prev, [field.field_name]: "Invalid email format." }));
          setModifiedUserData(prev => ({ ...prev, [field.field_name]: updatedValue }));
          return;
        } else {
          return; // Reject invalid non-email values immediately
        }
      }
    }

    // Apply minLength validation
    if (minLength && updatedValue.length < minLength) {
      // setError(true);
      setErrorMessage(prev => ({ ...prev, [field.field_name]: `Value should have ${maxLength} digits.` }));
    } else {
      // setError(false);
      setErrorMessage(prev => ({ ...prev, [field.field_name]: "" }));


    }

    if (field.field_type === "bankifsc") {
      if (value.length < 20 && /^[0-9]*$/.test(value.substring(4, 11))) {
        let ifsc = props.ifsc_details?.first_four_ifsc + value.substring(4, 11)
        setModifiedUserData(prev => ({ ...prev, [field.field_name]: ifsc }))
        setVerificationStatus({ ...VerificationStatus, isChanged: true, isVerified: false })
      }
    }

    if (field.field_name.toLowerCase().includes("ifsc") || (field.field_details && field.field_details.verify === "true")) {
      setVerificationStatus({ ...VerificationStatus, isChanged: true, isVerified: false })
      if ((field.field_details && field.field_details.verify === "true")) {
        if (value.length < 20 && /^[0-9]*$/.test(value)) {
          setModifiedUserData(prev => ({ ...prev, [field.field_name]: updatedValue }))
        }
        else {
          setModifiedUserData(prev => ({ ...prev, [field.field_name]: ModifiedUserData[field.field_name] }))
        }
      }
    }
    


    if (field.field_type === "bankname") {
      let bankname = props.ifsc_details?.Bankname
      setModifiedUserData(prev => ({ ...prev, [field.field_name]: bankname }))

    }

    // Update user data in one state update
    if ((field.field_details && field.field_details.verify === "true") === false && field.field_type !== "bankifsc" && field.field_type !== "bankname") {

      setModifiedUserData(prev => ({ ...prev, [field.field_name]: updatedValue }));
    }
  };


  const getMatch = (value, string) => {
    console.log(value, string);
    return value.includes(string);
  };
  // getMatch()

  const getKey = (obj, searchString) => {
    console.log(obj, searchString);
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && key.toUpperCase().includes(searchString.toUpperCase())) {
        return key;
      }
    }
    return null;
  };

  const handleDynamicGet = (field, params, values) => {
    // console.log(values);
    // console.log('para', params);
    if (field.field_name !== Lastcall) {
      console.log('field', field);
      if (field.field_details.parameters) {
        let postparams = {};
        params.forEach((field) => {
          console.log(field);
          if (typeof field === 'object') {
            Object.entries(field).map(([key, value]) => {
              console.log(key);
              console.log(value);
              let split = value.split('_');
              // let tt = field
              postparams[split[split.length - 1].toLowerCase()] = values[value] ? values[value] : UserData[0][value];
            });
          } else {
            let split = field.split('_');
            let key = field;
            postparams[split[split.length - 1].toLowerCase()] = values[key] ? values[key] : UserData[0][key];
          }

          // console.log(split);
          // console.log(key);
        });
        switch (field.field_details.method) {
          case 'GET':
            console.log('params');
            getDynamicDataWithParams(field, postparams, setDynamicData);
            setLastCall(field.field_name);
            break;
        }
      } else {
        console.log('fsdfsdfsdfds called');
        switch (field.field_details.method) {
          case 'GET':
            console.log('normal');
            DynamicGet(field, setDynamicData);
            setLastCall(field.field_name);

            break;

          default:
            break;
        }
      }
    }
  };


  // const handleImageView = (field) => {
  //     let url = UserData && UserData[0][field.field_name]
  //     getImagesCSPkyc(url, setImageUrl, handleImgeModelOpen, handleImageAlertOpen, setFileType, setIsLoading)
  // }

  useEffect(() => {
    if (props.category) {
      let data = props.category.fields.map(field => field.field_name)

      console.log("data", data, props.userId);
      GetFieldDataWithLoader(setUserData, data, props.userId, setIsLoading);
    }
  }, [])

  // console.log("Modified", ModifiedUserData);

  const HandleReuploadFile = (filename, file) => {
    SendReuploadFileCspList(file, filename, props.userId, handleAlertOpen, GetData, setIsLoading)
  }


  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  console.log("props", props);


  const handlePluginButton = async (name, value, details) => {

    switch (details.method) {
      case 'POST': {
        if (details.field_required) {
          if (details.verify) {
            if (!value[details.body[0]['value']] && !UserData[0][details.body[0]['value']]) {
              handleAlertOpen(`IFSC Code is required`, "error")
            }
            else if (!value[name] && !UserData[0][name]) {

              handleAlertOpen(`Account number is required`, "error")

            }
            else {
              const api = await CheckActiveApi(setIsLoading, handleAlertOpen)

              if (api?.data?.service_vendor === "BHARAT") {
                DynamicBankVerifyBharat(
                  value[details.body[0]['value']] ? value[details.body[0]['value']] : UserData[0][details.body[0]['value']] ? UserData[0][details.body[0]['value']] : props.ifsc_details?.first_four_ifsc,
                  value[name] ? value[name] : UserData[0][name],
                  name,
                  details.body[0]['fetch'],
                  handleAlertOpen,
                  setIsLoading,
                  setModifiedUserData,
                  details.body[0]['value'],
                  ModifiedUserData,
                  setVerificationStatus
                )
              }
              else {
                DynamicBankAccNumberVerify(
                  value[details.body[0]['value']] ? value[details.body[0]['value']] : UserData[0][details.body[0]['value']] ? UserData[0][details.body[0]['value']] : props.ifsc_details?.first_four_ifsc,
                  value[name] ? value[name] : UserData[0][name],
                  name,
                  details.body[0]['fetch'],
                  handleAlertOpen,
                  setIsLoading,
                  setModifiedUserData,
                  details.body[0]['value'],
                  ModifiedUserData,
                  setVerificationStatus
                );
              }


            }

          }
        }
      }
    }
  };


  console.log("verification", VerificationStatus);


  return (

    OpenViewAllDocs ?

      <ViewAllFiles userId={props.userId} field={OpenViewAllDocsData?.field} value={OpenViewAllDocsData?.item} handleClose={() => handleCloseViewAllDocs()} handleGet={GetData}/>

      :


      <Grid container spacing={2} padding={2} alignItems="center">
        <BackdropLoader open={IsLoading} />
        <SnackBar open={AlertOpen} message={AlertMessage} type={AlertSeverity} handleClose={handleAlertClose} />
        <SnackBar open={ImageAlertOpen} message="Unable to fetch the document" type="error" handleClose={handleImageAlertClose} />
        {/* <ImageModal open={OpenImageModel} image={ImageUrl} handleClose={handleImageModelClose} fileType={FileType} /> */}

        <Box
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            cursor: 'pointer',
            fontSize: '20px',
          }}
          onClick={props.handleClose}
        >
          <IoClose />
        </Box>


        {
          IsLoading ?
            <Stack height="100%" width="100%">
              <Box textAlign='center'>
                <p>Loading...</p>
              </Box>
            </Stack>
            :
            UserData && Array.isArray(UserData) && UserData.length > 0 ?
              props.category && props.category.fields.map((field) => (
                field.field_type === "Text"
                  ||
                  field.field_type === "Function Call"
                  ||
                  field.field_type === "bankname"
                  ||
                  field.field_type === "bankifsc" ?
                  <Grid item md={4} xs={12} key={field.field_id}>
                    <TextField
                      required={field.required}
                      id="outlined-basic"
                      label={field.field_display_name}
                      variant="standard"
                      error={ErrorMessage[field.field_name] ? true : false}
                      helperText={ErrorMessage[field.field_name] ? ErrorMessage[field.field_name] : ""}
                      size='medium'
                      disabled={VerificationStatus.isVerificationAvailable && VerificationStatus.isChanged && VerificationStatus.isVerified ? true : false}
                      value={
                        ModifiedUserData[field.field_name] || ModifiedUserData[field.field_name] === "" ?
                          ModifiedUserData[field.field_name]
                          :
                          UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                            UserData[0][field.field_name]
                            :
                            ""
                      }
                      fullWidth
                      onChange={(e) => handleChange(field, e.target.value)}
                      InputLabelProps={
                        { shrink: true }
                      }
                      inputProps={
                        {
                          readOnly: field.field_name === "csp_code" ? true : false
                        }
                      }
                    />
                  </Grid>
                  :
                  field.field_type === "Select List" || field.field_type === "Option" ?
                    <Grid item md={4} xs={12} key={field.field_id}>
                      <FormControl fullWidth variant='standard' required={field.required}>
                        <InputLabel id="demo-simple-select-label">{field.field_display_name}</InputLabel>
                        <Select
                          required={true}
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={ModifiedUserData[field.field_name] || ModifiedUserData[field.field_name] === "" ?
                            ModifiedUserData[field.field_name]
                            :
                            UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                              UserData[0][field.field_name]?.toLowerCase()
                              :
                              ""}
                          label={field.field_display_name}
                          onChange={(e) => handleChange(field, e.target.value)}
                        >
                          {
                            field.field_details.options.map((option) => (
                              <MenuItem key={option.value} value={option.value ? option.value?.toLowerCase() : ""}>{option.Displayname}</MenuItem>
                            ))
                          }
                        </Select>
                      </FormControl>
                    </Grid>
                    :

                    field.field_type === "Plugin" && field.field_details && field.field_details.button === 'false' ?

                      (
                        <Grid item md={4} xs={12} key={field.field_id}>
                          <FormControl
                            fullWidth
                            error={ErrorMessage[field.field_name] ? true : false}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                paddingTop: '12px', // Add padding to ensure proper space for value and label
                                background: sessionStorage.getItem(field.field_name) ? '#F9F3FC' : '',
                                '& .MuiFormLabel-asterisk': { color: 'red' }
                              }
                            }}
                            required={field.required ? true : false}
                            variant='standard'
                            size='small'
                          >
                            <InputLabel htmlFor="outlined-adornment-lname-register">{field.field_display_name}</InputLabel>

                            <Select
                              labelId="select-label"
                              onChange={(e) => handleChange(field, e.target.value)}
                              disabled={sessionStorage.getItem(field.field_name) ? true : false}
                              onFocus={() =>
                                field.field_details.parameters
                                  ? handleDynamicGet(field, field.field_details.parameters, ModifiedUserData)
                                  : handleDynamicGet(field)
                              }
                              id="select"
                              value={ModifiedUserData[field.field_name] || ModifiedUserData[field.field_name] === "" ?
                                ModifiedUserData[field.field_name]
                                :
                                UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                                  UserData[0][field.field_name]
                                  :
                                  ""}
                              name={field.field_name}
                              label="Select Option"
                              sx={{
                                '& .MuiSelect-select': {
                                  background: sessionStorage.getItem(field.field_name) ? '#F9F3FC' : ''
                                }
                              }}
                            >
                              <MenuItem sx={{ visibility: "hidden" }} value={ModifiedUserData[field.field_name] || ModifiedUserData[field.field_name] === "" ?
                                ModifiedUserData[field.field_name]
                                :
                                UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                                  UserData[0][field.field_name]
                                  :
                                  ""}>{ModifiedUserData[field.field_name] || ModifiedUserData[field.field_name] === "" ?
                                    ModifiedUserData[field.field_name]
                                    :
                                    UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                                      UserData[0][field.field_name]
                                      :
                                      ""}</MenuItem>
                              {
                                getMatch(field.field_name.toUpperCase(), 'STATE') ? (
                                  DynamicData ? (
                                    Object.entries(DynamicData).map(([key]) => (
                                      <MenuItem key={key} value={key}>
                                        {key}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem>Loading....</MenuItem>
                                  )
                                ) : getMatch(field.field_name.toUpperCase(), 'SUB_DISTRICT') ? (



                                  DynamicData && ModifiedUserData && ModifiedUserData[getKey(ModifiedUserData, 'DISTRICT')] !== '' || (UserData.length > 0 && UserData[0][getKey(UserData[0], 'DISTRICT')]) ? (
                                    DynamicData &&
                                    (ModifiedUserData[getKey(ModifiedUserData, 'DISTRICT')] || (UserData.length > 0 && UserData[0][getKey(UserData[0], 'DISTRICT')])) &&
                                    Object.entries(DynamicData).map(([key]) => (
                                      <MenuItem key={key} value={key}>
                                        {key}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem>Loading....</MenuItem>
                                  )
                                ) : getMatch(field.field_name.toUpperCase(), 'DISTRICT') ? (
                                  DynamicData && UserData.length > 0 && (getKey(ModifiedUserData, 'STATE') || getKey(UserData[0], 'STATE')) && (ModifiedUserData[getKey(ModifiedUserData, 'STATE')] || (UserData.length > 0 && UserData[0][getKey(UserData[0], 'STATE')])) ? (
                                    DynamicData &&
                                    (ModifiedUserData[getKey(ModifiedUserData, 'STATE')] || UserData[0][getKey(UserData[0], 'STATE')]) &&
                                    DynamicData[ModifiedUserData[getKey(ModifiedUserData, 'STATE')] || UserData[0][getKey(UserData[0], 'STATE')]] &&
                                    DynamicData[ModifiedUserData[getKey(ModifiedUserData, 'STATE')] || UserData[0][getKey(UserData[0], 'STATE')]].map((item, index) => (
                                      <MenuItem key={index} value={item}>
                                        {item}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem>Loading....</MenuItem>
                                  )
                                ) : getMatch(field.field_name.toUpperCase(), 'VILLAGE') ? (
                                  DynamicData && UserData.length > 0 &&
                                    ModifiedUserData &&
                                    (getKey(ModifiedUserData, 'SUB_DISTRICT') || getKey(UserData[0], 'SUB_DISTRICT')) &&
                                    (ModifiedUserData[getKey(ModifiedUserData, 'SUB_DISTRICT')] || UserData[0][getKey(UserData[0], 'SUB_DISTRICT')]) ? (
                                    DynamicData &&
                                    (ModifiedUserData[getKey(ModifiedUserData, 'SUB_DISTRICT')] || UserData[0][getKey(UserData[0], 'SUB_DISTRICT')]) &&
                                    DynamicData[ModifiedUserData[getKey(ModifiedUserData, 'SUB_DISTRICT')] || UserData[0][getKey(UserData[0], 'SUB_DISTRICT')]] &&
                                    DynamicData[ModifiedUserData[getKey(ModifiedUserData, 'SUB_DISTRICT')] || UserData[0][getKey(UserData[0], 'SUB_DISTRICT')]].map((item, index) => (
                                      <MenuItem key={index} value={item}>
                                        {item}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem>Loading....</MenuItem>
                                  )
                                ) : (
                                  <MenuItem>no match</MenuItem>
                                )

                                // DynamicData ?
                                //   DynamicData.map((item, index) => (
                                //     <MenuItem key={index}>{item}</MenuItem>
                                //   ))
                                //   :
                                //   <MenuItem>Loading....</MenuItem>
                              }
                            </Select>


                          </FormControl>
                        </Grid>
                      )

                      :


                      field.field_type === "Documents" ?
                        <Grid item md={4} xs={12} key={field.field_id}>
                          <table style={{ width: "100%" }}>
                            <tr>
                              <td>
                                <Typography variant='h5'>{field.field_display_name}</Typography>
                              </td>
                            </tr>
                            <tr style={{ widows: "100%" }}>
                              <td style={{ display: 'flex', justifyContent: 'flex-start', width: '50%', gap: 10 }}>
                                <Button
                                  disabled={UserData && UserData[0][field.field_name] ? false : true}
                                  variant='outlined'
                                  color='secondary'
                                  size='small'
                                  onClick={() => handleViewAllDocs(UserData && UserData[0][field.field_name], field)}
                                >View</Button>
                                <Button
                                  component="label"
                                  role={undefined}
                                  variant="contained"
                                  color='secondary'
                                  tabIndex={-1}
                                >
                                  Upload
                                  <VisuallyHiddenInput
                                    type="file"
                                    onChange={(event) => HandleReuploadFile(field.field_name, event.target.files[0])}
                                    multiple
                                  />
                                </Button>
                              </td>

                            </tr>
                          </table>
                        </Grid>
                        :

                        (field.field_type === "Plugin" && field.field_details && field.field_details.button !== 'false') ?
                          <Grid item md={4} xs={12} key={field.field_id}>

                            <TextField

                              type="text"
                              variant='standard'
                              value={ModifiedUserData[field.field_name] || ModifiedUserData[field.field_name] === "" ?
                                ModifiedUserData[field.field_name]
                                :
                                UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                                  UserData[0][field.field_name]
                                  :
                                  ""}
                              name={field.field_name}
                              label={field.field_display_name}
                              fullWidth
                              onChange={(e) => handleChange(field, e.target.value)}
                              // onBlur={handleBlur}
                              // onInput={handleAccNOInput}
                              sx={{
                                input: {
                                  background: VerificationStatus.isVerificationAvailable && VerificationStatus.isChanged && VerificationStatus.isVerified ? '#F9F3FC' : ''
                                }
                              }}
                              InputLabelProps={
                                {
                                  shrink: true,
                                }
                              }
                              disabled={
                                VerificationStatus.isVerificationAvailable && VerificationStatus.isChanged && VerificationStatus.isVerified ? true : false
                              }
                              InputProps={
                                {
                                  endAdornment: (
                                    <Button
                                      component="label"
                                      // role={undefined}
                                      variant="outlined"
                                      disabled={
                                        // sessionStorage.getItem(field.field_name) ? true : false
                                        VerificationStatus.isVerificationAvailable && VerificationStatus.isChanged && VerificationStatus.isVerified ? true : false
                                      }
                                      color={ModifiedUserData[`${field.field_name}_verify`] === 'true' ? 'success' : 'secondary'}
                                    // onClick={()=>handlePluginButton(field.field_name,values,field.field_details,setFieldValue)}
                                    >
                                      {field.field_details.button}
                                      <VisuallyHiddenInput
                                        name={ModifiedUserData[field.field_name]}
                                        onClick={() =>
                                          ModifiedUserData[`${field.field_name}_verify`] === 'true'
                                            ? null
                                            : handlePluginButton(
                                              field.field_name,
                                              ModifiedUserData,
                                              field.field_details,

                                            )
                                        }
                                      />
                                    </Button>
                                  )
                                }
                              }


                            // onChange={(e) => handleFileUpload(item.name, e.target.files[0])}
                            />

                          </Grid>
                          :
                          field.field_type === "Date" ?
                            <Grid item md={4} xs={12} key={field.field_id}>
                              <TextField
                                required={field.required}
                                id="outlined-basic"
                                label={field.field_display_name}
                                variant="standard"
                                type='date'
                                error={ErrorMessage[field.field_name] ? true : false}
                                helperText={ErrorMessage[field.field_name] ? ErrorMessage[field.field_name] : ""}
                                size='medium'
                                disabled={VerificationStatus.isVerificationAvailable && VerificationStatus.isChanged && VerificationStatus.isVerified ? true : false}
                                value={
                                  normalizeDate(ModifiedUserData[field.field_name] || ModifiedUserData[field.field_name] === "" ?
                                    ModifiedUserData[field.field_name]
                                    :
                                    UserData && Array.isArray(UserData) && UserData[0][field.field_name] ?
                                      UserData[0][field.field_name]
                                      :
                                      "")
                                }
                                fullWidth
                                onChange={(e) => handleChange(field, e.target.value)}
                                InputLabelProps={
                                  { shrink: true }
                                }
                                inputProps={
                                  {
                                    readOnly: field.field_name === "csp_code" ? true : false
                                  }
                                }
                              />
                            </Grid>
                            :
                            null
              ))
              :
              <Typography variant='h5' color='error' textAlign='center' width='100%'>No Data Found</Typography>
        }
        <Grid item xs={12} mt={1}>
          <Grid container justifyContent="center">
            <Grid item xs={3}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={handleSubmit}
                disabled={Object.getOwnPropertyNames(ModifiedUserData).length === 0 ? true : false}
                fullWidth
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

  );
}
